// OPHORUS - PRODUCT / MOBILE BOOKING BOTTOM SHEET
//
// Remplace l'ancien bloc gris (.__booking.__fixed_mobile) par un vrai bottom
// sheet : un ecran "hub" recapitulatif (Participants/Date/Heure pre-remplis +
// Total), chaque ligne ouvrant son propre ecran dedie, puis un ecran de
// confirmation avant reservation. Jamais deux ecrans a la fois, jamais de
// bouton "Close" (fermeture uniquement par swipe ou fleche retour).
//
// Ne reimplemente aucun appel AJAX : s'appuie sur les fonctions existantes du
// module product (calendar/getPrice/getPriceFromDate/saveBooking/...) et
// DEPLACE (jamais ne clone) les noeuds DOM reels des steppers/calendrier/
// horaires dans ses propres ecrans, pour ne pas dupliquer les selecteurs
// globaux utilises par common.js/drop.js/product.js.
import $ from 'jquery';
import mobile from '../utils/mobile';

const bookingSheet = {
	product: null,
	isOpen: false,
	currentScreen: 'hub',
	hasTransferReturn: false,

	init(productModule) {
		this.product = productModule;
		this.$sheet = $('#ophorus_booking_sheet');

		if (this.$sheet.length === 0) {
			return;
		}

		this.$backdrop = $('.__booking_sheet_backdrop');
		this.$back = this.$sheet.find('.__sheet_back');
		this.$title = this.$sheet.find('.__sheet_title');
		this.$screens = this.$sheet.find('.__sheet_screen');
		this.$continueBtn = this.$sheet.find('.__sheet_continue');
		this.$bookNowBtn = this.$sheet.find('.__sheet_book_now');

		this.relocateNodesIntoSheet();
		this.bindEvents();
		this.bindSwipeToDismiss();
		this.syncStepperMinusButtons();
	},

	// ------------------------------------------------------------------
	// Etat initial du bouton "-" : common.js#forms() ne le desactive qu'APRES
	// un premier clic, jamais au chargement - un stepper qui demarre a 0
	// (produit fraichement visite, sans participant deja en panier) affichait
	// donc un "-" cliquable pour rien - cf. retours utilisateur.
	// ------------------------------------------------------------------
	syncStepperMinusButtons() {
		const min = this.product.minQuantity || 0;
		const hasForceMinPers = $('input[name="force_min_pers"]').length > 0;

		$('input[data-op]').not('.__extra_opt').each(function () {
			const op = $(this).data('op');
			const value = parseInt($(this).val(), 10) || 0;
			const floor = hasForceMinPers ? min : 0;
			$(`button._minus[data-op="${op}"]`)
				.toggleClass('_disabled', value <= floor)
				.prop('disabled', value <= floor);
		});
	},

	// ------------------------------------------------------------------
	// DEPLACEMENT DES CONTROLES REELS (jamais de clone)
	// ------------------------------------------------------------------
	relocateNodesIntoSheet() {
		const $slot = (name) => this.$sheet.find(`[data-slot="${name}"]`);

		$('._menu_dropdown[data-drop="person"]').appendTo($slot('participants'));
		$('.__wrap_calendar').first().appendTo($slot('date'));

		if (this.product.type === 'TRANSFER') {
			// Horaire fixe (pas de creneaux multiples pour un transfert) :
			// simple ligne d'information, deplacee telle quelle.
			$('.__block_booking').not('._bl_TRANSFER, .--transfer-extras').has('[name="_transfer_time_01"]')
				.appendTo($slot('hours'));
		} else {
			$('._menu_dropdown[data-drop="hours"]').appendTo($slot('hours'));
		}

		const $transferReturn = $('._transfer_return_parameters');
		if ($transferReturn.length > 0) {
			this.hasTransferReturn = true;
			const $blocks = $transferReturn.find('.__block_booking');
			$($blocks.get(0)).appendTo($slot('transfer_return_date'));
			$($blocks.get(1)).appendTo($slot('transfer_return_hours'));

			this.$sheet.find('[data-open-screen="transfer_return_date"], [data-open-screen="transfer_return_hours"]')
				.removeAttr('hidden');
			this.$sheet.find('[data-confirm-value="transfer_return_date"], [data-confirm-value="transfer_return_hours"]')
				.closest('._row').removeAttr('hidden');
		}
	},

	// ------------------------------------------------------------------
	// EVENEMENTS
	// ------------------------------------------------------------------
	bindEvents() {
		$(document).on('click', '.__btn_open_booking', (e) => {
			e.preventDefault();
			this.open();
		});

		this.$sheet.on('click', '.__sheet_hub_row', (e) => {
			const screen = $(e.currentTarget).data('open-screen');
			if (screen) {
				this.goToScreen(screen);
			}
		});

		this.$back.on('click', () => this.goToScreen('hub'));

		this.$sheet.on('click', '[data-quick-date]', (e) => {
			const $btn = $(e.currentTarget);
			if ($btn.hasClass('_disabled')) {
				return;
			}
			const dateStr = $btn.data('quick-date') === 'today' ? this.getTodayStr() : this.getTomorrowStr();
			if (this.product.calendarObj) {
				this.product.calendarObj.setDate(dateStr, true);
			}
		});

		this.$continueBtn.on('click', () => {
			if (!this.canContinue(this.currentScreen)) {
				return;
			}
			this.goToScreen(this.currentScreen === 'hub' ? 'confirm' : 'hub');
		});

		this.$bookNowBtn.on('click', () => {
			if (this.canContinue('confirm')) {
				this.close();
				this.product.saveBooking();
			}
		});

		this.$backdrop.on('click', () => {
			// Pas de fermeture au clic sur le voile (swipe/fleche retour
			// uniquement, cf. specification) - le voile ne fait que capter
			// le clic pour ne pas le laisser passer a la fiche produit.
		});
	},

	// ------------------------------------------------------------------
	// OUVERTURE / FERMETURE
	// ------------------------------------------------------------------
	open() {
		if (this.isOpen) {
			return;
		}
		this.isOpen = true;

		mobile.closeMobileMenu();
		mobile.closeBasket();

		const p = this.product;
		const hasValidSelection = p.totalQuantity > 0 && p.dateChoosen && p.hourChoosen;

		this.$sheet.css('transform', '').addClass('_open').attr('aria-hidden', 'false');
		this.$backdrop.addClass('_show');
		$('html,body').addClass('_overflow');

		this.goToScreen(hasValidSelection ? 'confirm' : 'hub');
	},

	close() {
		if (!this.isOpen) {
			return;
		}
		this.isOpen = false;

		this.$sheet.removeClass('_open').attr('aria-hidden', 'true');
		this.$backdrop.removeClass('_show');
		$('html,body').removeClass('_overflow');

		this.updateCtaBar();
	},

	// ------------------------------------------------------------------
	// NAVIGATION ENTRE ECRANS
	// ------------------------------------------------------------------
	SCREEN_TITLES: {
		hub: 'Book your tour',
		participants: 'Participants',
		date: 'Select date',
		hours: 'Select departure time',
		transfer_return_date: 'Select return date',
		transfer_return_hours: 'Select return time',
		confirm: 'Your selection'
	},

	goToScreen(screen) {
		this.currentScreen = screen;

		this.$screens.removeClass('_active');
		this.$sheet.find(`.__sheet_screen[data-screen="${screen}"]`).addClass('_active');

		this.$title.text(this.SCREEN_TITLES[screen] || '');
		this.$back.prop('hidden', screen === 'hub');

		const isConfirm = screen === 'confirm';
		this.$continueBtn.prop('hidden', isConfirm);
		this.$bookNowBtn.prop('hidden', !isConfirm);

		if (screen === 'hub') {
			this.renderHub();
		} else if (screen === 'confirm') {
			this.renderConfirm();
		} else if (screen === 'date') {
			this.updateQuickDateButtons();
		} else if (screen === 'participants') {
			this.syncStepperMinusButtons();
		}

		this.updateContinueState();
		this.$sheet.find('.__sheet_content').scrollTop(0);
	},

	// ------------------------------------------------------------------
	// RACCOURCIS "TODAY" / "TOMORROW" - desactives si la date correspondante
	// n'est pas disponible (hors de "enable: dates" du calendrier).
	// ------------------------------------------------------------------
	getTodayStr() {
		return this.formatISODate(new Date());
	},

	getTomorrowStr() {
		const d = new Date();
		d.setDate(d.getDate() + 1);
		return this.formatISODate(d);
	},

	formatISODate(d) {
		const pad = (n) => String(n).padStart(2, '0');
		return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
	},

	// ------------------------------------------------------------------
	// Le choix d'horaire n'existe que sur certains produits (plusieurs
	// creneaux disponibles) - sur les autres (un seul creneau fixe, ou
	// TRANSFER dont l'heure n'est jamais une vraie liste), rien ne sert a
	// afficher une ligne "Departure" vide ni un ecran dedie inutile - cf.
	// retours utilisateur.
	// ------------------------------------------------------------------
	hasHoursChoice() {
		return this.$sheet.find('[data-slot="hours"] .__ul_hours li').length > 1;
	},

	updateHoursVisibility() {
		const hasChoice = this.hasHoursChoice();
		this.$sheet.find('.__sheet_hub_row[data-open-screen="hours"]').prop('hidden', !hasChoice);
		this.$sheet.find('[data-confirm-value="hours"]').closest('._row').prop('hidden', !hasChoice);
	},

	updateQuickDateButtons() {
		const dates = this.product.array_dates || {};
		this.$sheet.find('[data-quick-date="today"]')
			.toggleClass('_disabled', !dates[this.getTodayStr()]);
		this.$sheet.find('[data-quick-date="tomorrow"]')
			.toggleClass('_disabled', !dates[this.getTomorrowStr()]);
	},

	// ------------------------------------------------------------------
	// VALIDITE PAR ECRAN - le bouton Continue/Book now ne doit jamais faire
	// avancer l'utilisateur sur un choix incomplet (cf. retours utilisateur
	// "panier avec 0 utilisateurs").
	// ------------------------------------------------------------------
	canContinue(screen) {
		const p = this.product;

		switch (screen) {
			case 'participants':
				return p.totalQuantity > 0;
			case 'date':
				return !!p.dateChoosen;
			case 'hours':
				return !!p.hourChoosen;
			case 'transfer_return_date':
				return !!$('input[name="_transfer_date_round"]').val();
			case 'transfer_return_hours':
				return !!$('input[name="_transfer_time_02"]').val();
			case 'hub':
			case 'confirm': {
				// Sur un produit sans vrai choix d'horaire (cf.
				// hasHoursChoice()/updateHoursVisibility(), ligne Departure
				// masquee), hourChoosen n'est plus exigible pour continuer.
				const hoursOk = !this.hasHoursChoice() || !!p.hourChoosen;
				return p.totalQuantity > 0 && !!p.dateChoosen && hoursOk;
			}
			default:
				return true;
		}
	},

	updateContinueState() {
		const ok = this.canContinue(this.currentScreen);
		this.$continueBtn.prop('disabled', !ok).toggleClass('_disabled', !ok);
		this.$bookNowBtn.prop('disabled', !ok).toggleClass('_disabled', !ok);
	},

	// ------------------------------------------------------------------
	// RENDU HUB / CONFIRMATION
	// ------------------------------------------------------------------
	renderHub() {
		const p = this.product;

		this.$sheet.find('[data-hub-value="participants"]').text(p.buildParticipantsLabel());
		this.$sheet.find('[data-hub-value="date"]').text(this.formatDate(p.dateChoosen));
		this.$sheet.find('[data-hub-value="hours"]').text(p.hourChoosen || '—');
		this.$sheet.find('[data-hub-value="total"]').text(this.getCurrentTotalText());
		this.updateHoursVisibility();

		if (this.hasTransferReturn) {
			this.$sheet.find('[data-hub-value="transfer_return_date"]')
				.text(this.formatDate($('input[name="_transfer_date_round"]').val()));
			this.$sheet.find('[data-hub-value="transfer_return_hours"]')
				.text($('input[name="_transfer_time_02"]').val() || '—');
		}
	},

	renderConfirm() {
		const p = this.product;

		this.$sheet.find('[data-confirm-value="participants"]').text(p.buildParticipantsLabel());
		this.$sheet.find('[data-confirm-value="date"]').text(this.formatDate(p.dateChoosen));
		this.$sheet.find('[data-confirm-value="hours"]').text(p.hourChoosen || '—');
		this.$sheet.find('[data-confirm-value="price_unit"]').text(this.getUnitPriceText());
		this.$sheet.find('[data-confirm-value="total"]').text(this.getCurrentTotalText());
		this.updateHoursVisibility();

		if (this.hasTransferReturn) {
			this.$sheet.find('[data-confirm-value="transfer_return_date"]')
				.text(this.formatDate($('input[name="_transfer_date_round"]').val()));
			this.$sheet.find('[data-confirm-value="transfer_return_hours"]')
				.text($('input[name="_transfer_time_02"]').val() || '—');
		}
	},

	formatDate(dateStr) {
		if (!dateStr) {
			return '—';
		}
		const parts = dateStr.split('-');
		if (parts.length !== 3) {
			return dateStr;
		}
		const months = ['January', 'February', 'March', 'April', 'May', 'June',
			'July', 'August', 'September', 'October', 'November', 'December'];
		const [year, month, day] = parts;
		return `${parseInt(day, 10)} ${months[parseInt(month, 10) - 1]} ${year}`;
	},

	getCurrentTotalText() {
		const $total = $('.--price_total').find('span').first();
		return $total.length && $total.text() ? $total.text() : '—';
	},

	getUnitPriceText() {
		const $each = $('.__bl_line[data-bl="EACH"], .__bl_line[data-bl="CUSTOM"]').first().find('small');
		return $each.length && $each.text() ? $each.text() : '—';
	},

	// ------------------------------------------------------------------
	// BARRE CTA COLLANTE - appele depuis product.js#getPrice() succes
	// ------------------------------------------------------------------
	updateCtaBar() {
		const p = this.product;
		const hasValidSelection = p.totalQuantity > 0 && p.dateChoosen && p.hourChoosen;
		$('.__btn_open_booking > ._open > span').html(hasValidSelection ? 'Continue' : 'Check availability');
	},

	// ------------------------------------------------------------------
	// SWIPE-TO-DISMISS
	// ------------------------------------------------------------------
	bindSwipeToDismiss() {
		const self = this;
		const $dragZone = this.$sheet.find('.__sheet_handle, .__sheet_header');
		const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		let startY = 0;
		let startTime = 0;
		let deltaY = 0;
		let dragging = false;
		let ticking = false;

		const sheetHeight = () => this.$sheet[0].getBoundingClientRect().height || 1;

		$dragZone.on('touchstart', (e) => {
			if (reducedMotion) {
				return;
			}
			startY = e.originalEvent.touches[0].clientY;
			startTime = Date.now();
			deltaY = 0;
			dragging = true;
			self.$sheet.addClass('_dragging');
		});

		$dragZone.on('touchmove', (e) => {
			if (!dragging) {
				return;
			}
			const currentY = e.originalEvent.touches[0].clientY;
			const rawDelta = currentY - startY;
			// Forte resistance vers le haut : le sheet ne doit pas depasser
			// sa position ouverte.
			deltaY = rawDelta > 0 ? rawDelta : rawDelta * 0.15;

			if (!ticking) {
				ticking = true;
				requestAnimationFrame(() => {
					ticking = false;
					// touchend a pu se declencher entre la demande de frame et
					// son execution : sans cette garde, ce callback rejouait
					// un transform perime APRES le nettoyage de touchend,
					// laissant le sheet coince a mi-course au lieu de
					// remonter/se refermer proprement - cf. retours
					// utilisateur.
					if (!dragging) {
						return;
					}
					self.$sheet.css('transform', `translateY(${deltaY}px)`);
				});
			}
		});

		$dragZone.on('touchend', () => {
			if (!dragging) {
				return;
			}
			dragging = false;
			self.$sheet.removeClass('_dragging');
			self.$sheet.css('transform', '');

			const elapsed = Date.now() - startTime || 1;
			const velocity = deltaY / elapsed;
			const shouldClose = deltaY > sheetHeight() * 0.25 || velocity > 0.6;
			deltaY = 0;

			if (shouldClose) {
				self.close();
			}
		});
	}
};

export default bookingSheet;
